import { useContext } from 'react';
import { AppContext } from '../components/context/context.esm.js';

var useHeaderPanel = function() {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    var _useContext = useContext(AppContext), _useContext_openPanelKey = _useContext.openPanelKey, openPanelKey = _useContext_openPanelKey === void 0 ? '' : _useContext_openPanelKey, _useContext_setOpenPanelKey = _useContext.setOpenPanelKey, setOpenPanelKey = _useContext_setOpenPanelKey === void 0 ? function() {} : _useContext_setOpenPanelKey;
    return {
        openPanelKey: openPanelKey,
        setOpenPanelKey: setOpenPanelKey
    };
};

export { useHeaderPanel };
